import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { FormControl } from '@angular/forms';
import * as moment from 'moment';
import { InputDaterangeComponent } from '@ar2/common';
import { ViewChild } from '@angular/core';
/**
 * 日付範囲入力フィールド
 *【ラベル内容:labelContent:string】
 *【入力日付範囲:inputDateRange:{startDate:string, endDate:string}】
 *【日付フォーマット:dateFormat:string】
 *【表示条件:visible:boolean】
 *【非活性:disabled:boolean】
 *【フォームコントロール名:formControl:FormControl】
 *【レンジ開始日:minFrom:string】
 *【レンジ終了日:maxTo:string】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-input-daterange-field',
  templateUrl: './input-daterange-field.html',
  styles: [`
    
  `]
})
export class InputDaterangeField extends BaseWidget {
  /**
   * 入力日付範囲の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 入力日付範囲に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * ラベル内容
   */
  @Input() labelContent:string

  /**
   * 日付フォーマット
   */
  @Input() dateFormat:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * フォームコントロール名
   */
  @Input() formControl:FormControl

  /**
   * レンジ開始日
   */
  @Input() minFrom:string

  /**
   * レンジ終了日
   */
  @Input() maxTo:string

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * get datepicker
   */
  @ViewChild('daterange')
  public inputDaterangeComponent: InputDaterangeComponent;
  /**
   * format of ymd
   */
  private YMD = 'YYYY/MM/DD';
  /**
   * format of ym
   */
  private YM = 'YYYY/MM';
  /**
   * format of md
   */
  private MD = 'MM/DD';
  /**
   * 入力日付範囲
   */
  private _inputDateRange: {startDate: string, endDate: string};
  
  @Input()
  set inputDateRange(target: {startDate:string, endDate:string}) {
    this._inputDateRange = target;
    this.dateRange = '';
    this.showDateRange(target);
  }
  get inputDateRange(): {startDate:string, endDate:string} {
    return this._inputDateRange;
  }
  /**
   * 表示日付範囲
   */
  public dateRange: string;
  /**
   * Invalid date
   */
  public INVALID_DATE = 'Invalid date';
  /**
   * 表示日付を取得
   */
  showDateRange(target: {startDate: string, endDate: string}) {
    this.dateRange = '';
    let startDate = target.startDate
    let endDate = target.endDate
    if (this.inputDaterangeComponent) {
      startDate = startDate ? moment(moment(startDate).toDate()).format(this.inputDaterangeComponent.currentDateFormatCulture) : startDate
      endDate = endDate ? moment(moment(endDate).toDate()).format(this.inputDaterangeComponent.currentDateFormatCulture) : endDate
    }
    if (startDate) {
      this.dateRange = startDate;
    }
    if (startDate || endDate) {
      this.dateRange += '-';
    }
    if (endDate) {
      this.dateRange += endDate;
    }
  }
  
  /**
   * 入力日付範囲を取得する
   * @param data
   */
  public getSelectedDateRange(data) {
    let startDateBefore = this.inputDateRange.startDate;
    let endDateBefore = this.inputDateRange.endDate;
    const sta:Date = data.startDate;
    const end:Date = data.endDate;
    const formatter = this.dateFormat === 'ymd' ? this.YMD
                    : this.dateFormat === 'ym' ? this.YM
                    : this.dateFormat === 'md' ? this.MD
                    : this.YMD
    this._inputDateRange.startDate = moment(sta).format(formatter);
    this._inputDateRange.endDate = moment(end).format(formatter);
    if (this._inputDateRange.startDate === this.INVALID_DATE) {
      this._inputDateRange.startDate = '';
    }
    if (this._inputDateRange.endDate === this.INVALID_DATE) {
      this._inputDateRange.endDate = '';
    }
    this.showDateRange(this._inputDateRange);
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => this._inputDateRange,
      {id:this.id, type:data.event, source:new Event(data.event)},
      `update by ${this.id}`,
    ))
    if (startDateBefore !== this._inputDateRange.startDate
      || endDateBefore !== this._inputDateRange.endDate) {
      this.on("change");
    }
  }
  ngOnInit() {
    if(!this.formControl) {
      this.formControl = new FormControl('');
    }
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/input-daterange-field/input-daterange-field.component.ts